export const isImage = (type) => {
  switch (type) {
    case "image/gif":
    case "image/jpeg":
    case "image/png":
    case "image/tiff":
      return true;
    default:
      return false;
  }
};

export const isPdf = (type) => {
  return type === "application/pdf";
};

export const handleDownload = (url) => {
  let link = window.document.createElement("a");
  link.download = undefined;
  link.href = url;
  link.click();
};
